import { AssignedWellbeingReferralsPage } from "@features/wellbeing-referrals/components/AssignedWellbeingReferralsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/referrals/wellbeing/assigned/$category")({
	component: AssignedWellbeingReferralsPage,
});
